import React from 'react'
import Container from './Container/Container.jsx'
import Navigation from './Navigation/Navigation.jsx'
import Footer from './Footer/Footer.jsx'

class App extends React.Component{
  render(){
    return(
      <div>
        <Navigation/>
        <Container/>
        <Footer/>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx